// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2GAhk","log":"ModalInventoryLogs_log__1DkN1","date":"ModalInventoryLogs_date__1GPdp","userName":"ModalInventoryLogs_userName__3zQc5"};